import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
});

// Class name string passed to ImageUploader's imagePreviewClassName prop.
// The actual CSS rule is defined globally in ovid.scss (.publication-logo-image-preview).
export const IMAGE_PREVIEW_CLASS = 'publication-logo-image-preview';
